import { SelectOption } from '@/models/selectOption'

export const PRIORITY_TYPES = {
  HIGH: 'Alta',
  MEDIUM: 'Média',
  LOW: 'Baixa',
}

export const PRIORITY_TYPES_OPTIONS: SelectOption[] = [
  {
    label: PRIORITY_TYPES.HIGH,
    value: PRIORITY_TYPES.HIGH,
  },
  {
    label: PRIORITY_TYPES.LOW,
    value: PRIORITY_TYPES.LOW,
  },
  {
    label: PRIORITY_TYPES.MEDIUM,
    value: PRIORITY_TYPES.MEDIUM,
  },
]

export const SOLUTION_TYPES = {
  TEXT: 'text',
  LINK: 'link',
  FILE: 'file',
  AUDIO: 'audio',
  IMAGE: 'image',
}

export const SOLUTION_TYPES_LABELS = {
  [SOLUTION_TYPES.TEXT]: 'Texto',
  [SOLUTION_TYPES.LINK]: 'Link',
  [SOLUTION_TYPES.FILE]: 'PDF',
  [SOLUTION_TYPES.AUDIO]: 'Audio',
  [SOLUTION_TYPES.IMAGE]: 'Imagem',
}

export const SOLUTION_TYPES_OPTIONS: SelectOption[] = [
  {
    label: SOLUTION_TYPES_LABELS[SOLUTION_TYPES.IMAGE],
    value: SOLUTION_TYPES.IMAGE,
  },
  {
    label: SOLUTION_TYPES_LABELS[SOLUTION_TYPES.AUDIO],
    value: SOLUTION_TYPES.AUDIO,
  },
  {
    label: SOLUTION_TYPES_LABELS[SOLUTION_TYPES.FILE],
    value: SOLUTION_TYPES.FILE,
  },
  {
    label: SOLUTION_TYPES_LABELS[SOLUTION_TYPES.LINK],
    value: SOLUTION_TYPES.LINK,
  },
  {
    label: SOLUTION_TYPES_LABELS[SOLUTION_TYPES.TEXT],
    value: SOLUTION_TYPES.TEXT,
  },
]

export const MESSAGE_TYPES = {
  TEXT: 'text',
  FILE: 'file',
  BUTTON: 'button',
  CONTACT: 'contact',
  UNSUPPORTED: 'unsupported',
}

export const WHATSAPP_UNSUPPORTED_TYPES = {
  UAZAPI_MEDIA_ERROR: 'uazapi_media_error',
  UAZAPI_MESSAGE_ERROR: 'uazapi_message_error',
} as const

export const FILE_TYPES = {
  DOCUMENT: 'document',
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
}

export const FILE_TYPE_LABELS = {
  [FILE_TYPES.DOCUMENT]: 'Arquivo',
  [FILE_TYPES.IMAGE]: 'Imagem',
  [FILE_TYPES.VIDEO]: 'Vídeo',
  [FILE_TYPES.AUDIO]: 'Áudio',
}

export const FILE_TYPE_MIME_MAP = {
  [FILE_TYPES.IMAGE]: 'image/*',
  [FILE_TYPES.VIDEO]: 'video/mp4',
  [FILE_TYPES.AUDIO]: 'audio/mpeg',
  [FILE_TYPES.DOCUMENT]: 'application/pdf',
}

export const SETTING_FILE_TYPES = {
  PDF: 'pdf',
  VIDEO: 'video',
  IMAGE: 'image',
}

export const JOURNEY_STAGE_TYPES = {
  TEXT: 'text',
  LINK: 'link',
  PDF: 'pdf',
  AUDIO: 'audio',
  VIDEO: 'video',
  IMAGE: 'image',
}

export const JOURNEY_STAGE_TYPES_LABELS = {
  [JOURNEY_STAGE_TYPES.AUDIO]: 'Audio',
  [JOURNEY_STAGE_TYPES.LINK]: 'Link',
  [JOURNEY_STAGE_TYPES.PDF]: 'PDF',
  [JOURNEY_STAGE_TYPES.TEXT]: 'Texto',
  [JOURNEY_STAGE_TYPES.VIDEO]: 'Video',
  [JOURNEY_STAGE_TYPES.IMAGE]: 'Imagem',
}

export const JOURNEY_STAGE_TYPES_OPTIONS: SelectOption[] = [
  {
    label: JOURNEY_STAGE_TYPES_LABELS[JOURNEY_STAGE_TYPES.AUDIO],
    value: JOURNEY_STAGE_TYPES.AUDIO,
  },
  {
    label: JOURNEY_STAGE_TYPES_LABELS[JOURNEY_STAGE_TYPES.LINK],
    value: JOURNEY_STAGE_TYPES.LINK,
  },
  {
    label: JOURNEY_STAGE_TYPES_LABELS[JOURNEY_STAGE_TYPES.PDF],
    value: JOURNEY_STAGE_TYPES.PDF,
  },
  {
    label: JOURNEY_STAGE_TYPES_LABELS[JOURNEY_STAGE_TYPES.TEXT],
    value: JOURNEY_STAGE_TYPES.TEXT,
  },
  {
    label: JOURNEY_STAGE_TYPES_LABELS[JOURNEY_STAGE_TYPES.VIDEO],
    value: JOURNEY_STAGE_TYPES.VIDEO,
  },
  {
    label: JOURNEY_STAGE_TYPES_LABELS[JOURNEY_STAGE_TYPES.IMAGE],
    value: JOURNEY_STAGE_TYPES.IMAGE,
  },
]

export const JOURNEY_STAGE_CATEGORIES = {
  ONBOARDING: 'onboarding',
  RELATIONSHIP: 'relationship',
  UPSELL_CROSS_SELL: 'upsell_cross_sell',
  ADVOCATE: 'advocate',
} as const

export const JOURNEY_STAGE_CATEGORY_LABELS = {
  [JOURNEY_STAGE_CATEGORIES.ONBOARDING]: 'Onboarding',
  [JOURNEY_STAGE_CATEGORIES.RELATIONSHIP]: 'Relacionamento',
  [JOURNEY_STAGE_CATEGORIES.UPSELL_CROSS_SELL]: 'Upsell + Cross-sell',
  [JOURNEY_STAGE_CATEGORIES.ADVOCATE]: 'Defensor',
}

export const JOURNEY_STAGE_CATEGORY_COLORS = {
  [JOURNEY_STAGE_CATEGORIES.ONBOARDING]: '#438BE8',
  [JOURNEY_STAGE_CATEGORIES.RELATIONSHIP]: '#F0AA1C',
  [JOURNEY_STAGE_CATEGORIES.UPSELL_CROSS_SELL]: '#7770DE',
  [JOURNEY_STAGE_CATEGORIES.ADVOCATE]: '#32BB8A',
}

export const JOURNEY_STAGE_CATEGORY_TEXT_COLOR = '#111827'

export const JOURNEY_STAGE_CATEGORY_OPTIONS: SelectOption[] = Object.values(
  JOURNEY_STAGE_CATEGORIES
).map((value) => ({
  value,
  label: JOURNEY_STAGE_CATEGORY_LABELS[value],
}))

export const CLIENT_TYPES = {
  SERVICE: 'Serviço',
  BUSINESS: 'Comércio',
  INDUSTRY: 'Indústria',
  SERVICE_BUSINESS: 'Serviço/Comércio',
  INDUSTRY_BUSINESS: 'Indústria/Comércio',
  INDUSTRY_BUSINESS_SERVICE: 'Indústria/Comércio/Serviço',
  IRPF: 'IRPF',
  DOMESTIC: 'Doméstica',
  CARNET_LEAO: 'Carnê-Leão',
  RURAL_PRODUCT: 'Produto Rural',
  POLITICAL: 'Político',
}

export const CLIENT_PJ_TYPE_OPTIONS: SelectOption[] = [
  { label: CLIENT_TYPES.SERVICE, value: CLIENT_TYPES.SERVICE },
  { label: CLIENT_TYPES.BUSINESS, value: CLIENT_TYPES.BUSINESS },
  { label: CLIENT_TYPES.INDUSTRY, value: CLIENT_TYPES.INDUSTRY },
  {
    label: CLIENT_TYPES.SERVICE_BUSINESS,
    value: CLIENT_TYPES.SERVICE_BUSINESS,
  },
  {
    label: CLIENT_TYPES.INDUSTRY_BUSINESS,
    value: CLIENT_TYPES.INDUSTRY_BUSINESS,
  },
  {
    label: CLIENT_TYPES.INDUSTRY_BUSINESS_SERVICE,
    value: CLIENT_TYPES.INDUSTRY_BUSINESS_SERVICE,
  },
]

export const CLIENT_PF_TYPE_OPTIONS: SelectOption[] = [
  {
    label: CLIENT_TYPES.IRPF,
    value: CLIENT_TYPES.IRPF,
  },
  {
    label: CLIENT_TYPES.DOMESTIC,
    value: CLIENT_TYPES.DOMESTIC,
  },
  {
    label: CLIENT_TYPES.CARNET_LEAO,
    value: CLIENT_TYPES.CARNET_LEAO,
  },
  {
    label: CLIENT_TYPES.RURAL_PRODUCT,
    value: CLIENT_TYPES.RURAL_PRODUCT,
  },
  {
    label: CLIENT_TYPES.POLITICAL,
    value: CLIENT_TYPES.POLITICAL,
  },
]

export const CLIENT_TYPE_OPTIONS: SelectOption[] = [
  ...CLIENT_PJ_TYPE_OPTIONS,
  ...CLIENT_PF_TYPE_OPTIONS,
]

export const CLIENT_SIZES = {
  ME: 'ME',
  MEI: 'MEI',
  EPP: 'EPP',
  PF: 'PF',
  OTHERS: 'Demais',
}

export const CLIENT_SIZES_LABELS = {
  [CLIENT_SIZES.ME]: 'ME',
  [CLIENT_SIZES.MEI]: 'MEI',
  [CLIENT_SIZES.EPP]: 'EPP',
  [CLIENT_SIZES.PF]: 'PF',
  [CLIENT_SIZES.OTHERS]: 'Demais',
}

export const CLIENT_SIZE_OPTIONS: SelectOption[] = [
  { label: CLIENT_SIZES_LABELS[CLIENT_SIZES.ME], value: CLIENT_SIZES.ME },
  { label: CLIENT_SIZES_LABELS[CLIENT_SIZES.MEI], value: CLIENT_SIZES.MEI },
  { label: CLIENT_SIZES_LABELS[CLIENT_SIZES.EPP], value: CLIENT_SIZES.EPP },
  { label: CLIENT_SIZES_LABELS[CLIENT_SIZES.PF], value: CLIENT_SIZES.PF },
  {
    label: CLIENT_SIZES_LABELS[CLIENT_SIZES.OTHERS],
    value: CLIENT_SIZES.OTHERS,
  },
]

export const CONTACT_PROFILES = {
  DOMINANT: 'dominant',
  INFLUENCE: 'influence',
  CAUTION: 'caution',
  STABILITY: 'stability',
}

export const CONTACT_PROFILES_LABELS = {
  [CONTACT_PROFILES.DOMINANT]: 'Dominante',
  [CONTACT_PROFILES.INFLUENCE]: 'Influência',
  [CONTACT_PROFILES.CAUTION]: 'Cautela',
  [CONTACT_PROFILES.STABILITY]: 'Estabilidade',
}

export const CONTACT_GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
  NON_BINARY: 'non-binary',
}

export const CONTACT_GENDERS_LABELS = {
  [CONTACT_GENDERS.MALE]: 'Masculino',
  [CONTACT_GENDERS.FEMALE]: 'Feminino',
  [CONTACT_GENDERS.NON_BINARY]: 'Não-binário',
}

export const CONTACT_GENDER_OPTIONS: SelectOption[] = [
  {
    label: CONTACT_GENDERS_LABELS[CONTACT_GENDERS.FEMALE],
    value: CONTACT_GENDERS.FEMALE,
  },
  {
    label: CONTACT_GENDERS_LABELS[CONTACT_GENDERS.MALE],
    value: CONTACT_GENDERS.MALE,
  },
  {
    label: CONTACT_GENDERS_LABELS[CONTACT_GENDERS.NON_BINARY],
    value: CONTACT_GENDERS.NON_BINARY,
  },
]

export const RECURRENCE_TYPES = {
  DAILY: 'Diária',
  WEEKLY: 'Semanal',
  MONTHLY: 'Mensal',
  QUARTELY: 'Trimestral',
}

export const RECURRENCE_TYPES_LIST = [
  RECURRENCE_TYPES.DAILY,
  RECURRENCE_TYPES.WEEKLY,
  RECURRENCE_TYPES.MONTHLY,
  RECURRENCE_TYPES.QUARTELY,
]

export enum ADMIN_INDICATOR_PERIOD {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
}

export const ADMIN_INDICATOR_PERIOD_LABELS = {
  [ADMIN_INDICATOR_PERIOD.TODAY]: 'Hoje',
  [ADMIN_INDICATOR_PERIOD.YESTERDAY]: 'Ontem',
  [ADMIN_INDICATOR_PERIOD.THIS_MONTH]: 'Este mês',
  [ADMIN_INDICATOR_PERIOD.LAST_MONTH]: 'Mês passado',
}

export const ADMIN_INDICATOR_PERIOD_OPTIONS: SelectOption[] = [
  {
    value: ADMIN_INDICATOR_PERIOD.TODAY,
    label: ADMIN_INDICATOR_PERIOD_LABELS[ADMIN_INDICATOR_PERIOD.TODAY],
  },
  {
    value: ADMIN_INDICATOR_PERIOD.YESTERDAY,
    label: ADMIN_INDICATOR_PERIOD_LABELS[ADMIN_INDICATOR_PERIOD.YESTERDAY],
  },
  {
    value: ADMIN_INDICATOR_PERIOD.THIS_MONTH,
    label: ADMIN_INDICATOR_PERIOD_LABELS[ADMIN_INDICATOR_PERIOD.THIS_MONTH],
  },
  {
    value: ADMIN_INDICATOR_PERIOD.LAST_MONTH,
    label: ADMIN_INDICATOR_PERIOD_LABELS[ADMIN_INDICATOR_PERIOD.LAST_MONTH],
  },
]
